// mizmiz-favorites.js
// Ürün kartlarındaki favori (kalp) butonunun davranışı.
// Önceden her kartta tekrar tekrar gömülüyordu, şimdi tek dosya olarak
// bir kere yükleniyor (performans için).

(function () {
  function positionCardHearts() {
    var wraps = document.querySelectorAll(".mizmiz-favorite-wrap--card:not(.mizmiz-positioned)");

    wraps.forEach(function (wrap) {
      var card = wrap.closest("product-card");
      if (!card) return;

      // ÖNEMLİ: card-gallery'nin kendisine ekliyoruz (fotoğrafı saran <a>
      // linkinin İÇİNE değil, dışına/kardeşine) - böylece kalp asla bir
      // linkin içinde olmaz, tıklaması ürün sayfasına yönlendiremez.
      var target = card.querySelector(".card-gallery") ||
                   card.querySelector("slideshow-component") ||
                   card.querySelector("img")?.parentElement;
      if (!target) return;

      wrap.classList.add("mizmiz-positioned");

      // ÖNEMLİ (performans): Burada eskiden getComputedStyle(target).position
      // okuyorduk - bu, öncesindeki/sonrasındaki DOM yazma işlemleriyle iç içe
      // girince tarayıcıyı "forced reflow" yapmaya zorluyordu (her kart için
      // ayrı ayrı, koleksiyon sayfasında ciddi yavaşlığa yol açıyordu).
      // Artık hiç okuma yapmadan doğrudan yazıyoruz - CSS dosyasında da aynı
      // kural zaten tanımlı (çift güvence, okuma gerektirmiyor).
      target.style.position = "relative";

      if (wrap.parentElement !== target) {
        target.appendChild(wrap);
      }
      wrap.classList.add("mizmiz-ready");
    });
  }

  function handleHeartClick(btn) {
    if (btn.disabled) return;
    btn.disabled = true;
    btn.classList.add("mizmiz-bound");

    var productId = btn.getAttribute("data-product-id");
    if (!productId) {
      var cardEl = btn.closest("product-card");
      productId = cardEl && cardEl.getAttribute("data-product-id");
    }
    if (!productId) {
      console.error("Favori butonu için ürün ID bulunamadı, istek gönderilmedi.");
      btn.disabled = false;
      return;
    }

    fetch("/apps/favorites/toggle?product_id=" + encodeURIComponent(productId), {
      method: "POST",
    })
      .then(function (res) {
        if (!res.ok) throw new Error("Request failed: " + res.status);
        return res.json();
      })
      .then(function (data) {
        btn.classList.toggle("is-favorited", data.favorited);
        btn.setAttribute("aria-pressed", data.favorited);
      })
      .catch(function (err) {
        console.error("Failed to update favorite:", err);
      })
      .finally(function () {
        btn.disabled = false;
      });
  }

  // Temanın kendi "view transition" / kart linki sistemi tıklamayı erken bir
  // aşamada (capture fazında) yakalayıp ürün sayfasına yönlendirebiliyor.
  // Bunu önlemek için kendi dinleyicimizi document üzerinde, capture=true ile
  // (yani her şeyden ÖNCE çalışacak şekilde) kuruyoruz.
  document.addEventListener(
    "click",
    function (event) {
      var btn = event.target.closest && event.target.closest(".mizmiz-favorite-wrap--card .mizmiz-favorite-btn");
      if (!btn || btn.tagName === "A") return;

      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();

      handleHeartClick(btn);
    },
    true // capture
  );

  function init() {
    positionCardHearts();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  window.addEventListener("load", init);
  setTimeout(init, 500);
  setTimeout(init, 1500);

  window.mizmizPositionCardHearts = positionCardHearts;

  // Sonradan yüklenen kartları (sonsuz kaydırma / lazy load) yakalamak için
  // sayfayı izliyoruz - kısa bir gecikmeyle (debounce) toplu kontrol ediyoruz.
  var debounceTimer = null;
  var observer = new MutationObserver(function () {
    if (debounceTimer) return;
    debounceTimer = setTimeout(function () {
      debounceTimer = null;
      init();
    }, 300);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();